<div>
    <mat-label style="display: block; font-size: 25px; margin-bottom: 20px; text-align: center;">
        Créer l'entreprise avec ce SIREN : {{data.siren}} ?
    </mat-label>
    <div>
        <button (click)="cancel()" style="background: darkred; float: right;">Annuler</button>
        <button (click)="accept()" style="background: green; float: left;">Accepter</button>
    </div>
</div>
